import React, { useState, useEffect } from 'react';
import { Collapse, Flex, Typography, Checkbox, Button, Tooltip } from 'antd';
import useNetworkAccounts from 'store/redux/hooks/useNetworkAccounts';
import AccountsCollapse from './component/AccountsCollapse';
import { AccountFormatter } from 'components/tables/NinjaTable/formatters/sourceFormatters';
import Icon from '@mdi/react';
import { mdiHelpCircleOutline } from '@mdi/js';
import Ninja from '@ninja';
import { snackbar } from 'components/notifications/notifications';

const { Panel } = Collapse;

const CampaignSpent = ({
  store,
  campaignSpentSave,
  isLoading,
  getCampaignSpentQuery,
  data,
  params = 'integration_id',
  extraAction,
}) => {
  const { accounts } = useNetworkAccounts({});
  const [defaultValues, setDefaultValue] = useState({
    network_account_ids: data?.exclude?.network_account_ids || [],
    network_campaign_ids: data?.exclude?.network_campaign_ids || [],
  });

  useEffect(() => {
    getCampaignSpentQuery({ [params]: store.id })
      .unwrap()
      .then((data) => {
        setCheckedAccounts(data?.exclude?.network_account_ids || []);
        setCheckedCampaign(data?.exclude?.network_campaign_ids || []);
        setDefaultValue(data?.exclude);
      });
  }, [store.id]);

  const [checkedAccounts, setCheckedAccounts] = useState(defaultValues?.network_account_ids);
  const [checkedCampaign, setCheckedCampaign] = useState(defaultValues?.network_campaign_ids);

  useEffect(() => {
    if (accounts?.length && defaultValues?.network_account_ids) {
      const initialChecked = accounts
        .filter((acc) => defaultValues?.network_account_ids?.includes(acc.id))
        .map((acc) => acc.id);
      setCheckedAccounts(initialChecked);
    }
  }, [accounts]);

  const onAccountCheck = (accountId, checked) => {
    setCheckedAccounts((prev) => {
      if (checked) {
        if (!prev?.includes(accountId)) return [...prev, accountId];
        return prev;
      } else {
        return prev.filter((id) => id !== accountId);
      }
    });
  };

  const onCampaignCheck = (campId, checked) => {
    setCheckedCampaign((prev) => {
      if (checked) {
        if (!prev?.includes(campId)) return [...prev, campId];
        return prev;
      } else {
        return prev.filter((id) => id !== campId);
      }
    });
  };

  const updateCampaignSpent = () => {
    campaignSpentSave({
      [params]: store.id,
      exclude: {
        network_account_ids: checkedAccounts,
        network_campaign_ids: checkedCampaign,
      },
    })
      .unwrap()
      .then((data) => {
        snackbar.success('Campaign spent updated successfully');
      })
      .catch((error) => {
        console.log(error);
        snackbar.error('Failed to update campaign spent:');
      });
  };

  return (
    <div className='campaign-collapse'>
      <Collapse key={store.id} className='!p-0' defaultActiveKey={[store.id]}>
        <Panel
          key={store.id}
          extra={extraAction}
          header={
            <Flex gap='small' className='w-full'>
              {store?.type && (
                <img src={`/icons/integrations/${store?.type}.svg`} className='w-5 rounded-full' />
              )}
              <Typography className='text-sm font-normal'>{store?.name}</Typography>
            </Flex>
          }
        >
          <div className='px-4 py-2'>
            {accounts?.map((account) => (
              <div key={account.id} className='campaign-spent'>
                <Collapse className='!p-0'>
                  <Panel
                    header={
                      <Flex justify='space-between' className='w-full'>
                        <Flex gap='middle'>
                          <Checkbox
                            checked={checkedAccounts?.includes(account.id)}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => onAccountCheck(account.id, e.target.checked)}
                          />
                          <AccountFormatter row={{ account }} />
                        </Flex>
                        {checkedAccounts?.includes(account.id) && (
                          <Tooltip title='Account is excluded' placement='top'>
                            <Icon path={mdiHelpCircleOutline} color={Ninja.colors.light} />
                          </Tooltip>
                        )}
                      </Flex>
                    }
                  >
                    <AccountsCollapse
                      account={account}
                      checkedCampaign={checkedCampaign}
                      checkedAll={checkedAccounts?.includes(account.id)}
                      onChange={(id, checked) => onCampaignCheck(id, checked)}
                    />
                  </Panel>
                </Collapse>
              </div>
            ))}
            <Button
              loading={isLoading}
              onClick={updateCampaignSpent}
              type='primary'
              size='medium'
              className='m-auto flex justify-center'
            >
              Save
            </Button>
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

export default CampaignSpent;
